import PropTypes from 'prop-types';
import React from 'react';
import { get } from '../../server';
import { connect } from 'react-redux';
import * as urlHelper from 'Helpers/url';
import { getSelectedLangCode } from 'Selectors/config';
import { getType } from 'Reducers/helpers/typeModifier';
import { urls } from '../../reducers/maps';
import { StaticMap } from 'panamera-react-ui';
import { compose } from 'redux';
import withConfig from 'HOCs/withConfig/withConfig';
import { convertToAbsoluteImageURI } from 'Helpers/images';

export const StaticMapWrapper = props => {
    return <StaticMap { ...props } />;
};

StaticMapWrapper.propTypes = {
    isFetching: PropTypes.func, // eslint-disable-line react/no-unused-prop-types
    staticMapUrl: PropTypes.func,
    getStaticMapUrl: PropTypes.func,
    config: PropTypes.object,
    isStaticUrl: PropTypes.bool,
    staticMapUrlString: PropTypes.string
};

const mapStateToProps = (state, { config, isStaticUrl, staticMapUrlString }) => {
    const queryParam = {};
    const lang = getSelectedLangCode(state);
    const staticAsseturl = config.get('staticAssets');
    const theme = config.get('theme', 'id');

    if (lang) {
        queryParam.lang = state.api.queryParam.lang;
    }

    const filteredStaticMapUrl = staticMapUrlString ?? urls.staticMapUrl;
    const staticUrl = convertToAbsoluteImageURI(filteredStaticMapUrl, '', staticAsseturl, '', '', theme);

    return {
        isFetching: params => state.maps.isFetching[getType('MAPS', `${ urls.getStaticMapUrl }?${ urlHelper.paramsToQueryString({ ...params, ...queryParam }) }`)],
        staticMapUrl: params => (isStaticUrl ? staticUrl
            : state.maps.collections[getType('MAPS', `${ urls.getStaticMapUrl }?${ urlHelper.paramsToQueryString({ ...params, ...queryParam }) }`)])
    };
};

const mapDispatchToProps = dispatch => {
    return {
        getStaticMapUrl: (params = {}) => dispatch(get(urls.getStaticMapUrl, 'MAPS', params))
    };
};

export default compose(
    withConfig,
    connect(mapStateToProps, mapDispatchToProps))(StaticMapWrapper);
